import Config from '../libs/config';

let loader;

export default {
  namespaced: true,
  state: () => ({
    id      : null,
    nickname: null,
    imageUrl: null,
    url     : null,
  }),
  mutations: {
    setProfile(state, profile) {
      state.id       = profile.id;
      state.nickname = profile.nickname || 'ニックネーム未設定';
      state.imageUrl = profile.imageUrl;
      state.url      = profile.url || Config.SERVICE_LINK.ATCOSME.USER.URL;
    },
  },
  actions: {
    fetchSelf({ state, commit, rootState }) {
      if (state.id) {
        return Promise.resolve();
      }
      if (loader) {
        return loader;
      }
      const id = rootState.context.viewer.istyleId;
      const url = new URL(`/v1/objects/uid/${id}`, Config.ACTION_API.URL_BASE.GLOBAL);
      return loader = (this._vm.$fetch || window.fetch)(url)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }
          return response.json();
        })
        .then((uidObject) => {
          commit('setProfile', {
            id      : parseInt(uidObject.id, 10),
            nickname: uidObject.label,
            imageUrl: uidObject.image.url,
            url     : uidObject.url,
          });
        })
        .catch((error) => {
          commit('setProfile', { id });
          throw error;
        });
    },
  },
};
